export enum ProfileLngKeys {
  ChangedEmail = 'Changed email',
  ChangedEmailParagraph1 = 'Changed email paragraph 1',
  ChangedEmailParagraph2 = 'Changed email paragraph 2',
  EnterNewEmailAddress = 'Enter a new email address',
  ChangedPassword = 'Changed password',
  EnterCurrentPassword = 'Enter your current password',
  CreateNewPassword = 'Create a new password',
  RepeatEnteredPassword = 'Repeat the entered password again',
  EditProfile = 'Edit profile',
  WhatIsYourFirstName = 'What are you first name',
  WhatIsYourLastName = 'What are you last name',
  ChooseYourGender = 'Choose your gender',
  WillYouChooseYourDateOfBirth = 'Will you choose your date of birth',
  WhatIsTheNameOfTheCompany = 'What is the name of the company',
  WhatIsTheNameOfYourProfession = 'What is the name of your profession',
  WillYouChooseStartDateForWorking = 'Will you choose a start date for working for this company',
  YourRatePerHourOfWork = 'Your rate per hour of work',
  DeleteProfile = 'Delete profile',
  DeleteProfileParagraph1 = 'Delete profile paragraph 1',
  UploadAvatar = 'Upload avatar',
  UploadAvatarParagraph1 = 'Upload avatar paragraph 1',
  ExampleDescriptionForUser = 'Example description for user',
  WriteFewWordsAboutYourself = 'Write a few words about yourself',
  HelloHereWantedToTellYouLittleAboutMyself = 'Hello, here I wanted to tell you a little about myself',
  CalculationSetup = 'Calculation setup',
  SelectContractType = 'Select contract type',
  AreYouAlreadyYearsOld = 'Are you already 26 years old',
  AreYouParticipantInPPK = 'Are you a participant in the PPK program',
  SettingsHaveBeenSuccessfullyChanged = 'The settings have been successfully changed',
  UserData = 'User data',
  CalculationSettings = 'Calculation settings',
  ContractType = 'Contract type',
  Full26Years = 'Full 26 years',
  ParticipantOfPpkProgram = 'Participant of the PPK program',
  PpkContributionRateYouPay = 'PPK contribution rate you pay',
  MinimumValueAndMaximum = 'Minimum value and maximum',
  AccountInformationSuccessfullyUpdated = 'Your account information has been successfully updated',
  EmailAddressHasBeenSuccessfullyChanged = 'The email address has been successfully changed',
  PasswordHasBeenSuccessfullyChanged = 'The password has been successfully changed',
  PasswordResetEmailSuccessfullySent = 'A password reset email has been successfully sent to your email address',
  AvatarHasBeenSuccessfullyChanged = 'The avatar has been successfully changed',
}
